import {Temporal} from "temporal-polyfill";
import {GjeldendeTidssone} from "./i18n/GjeldendeTidssone";
import {Injectable} from "@angular/core";
import ZonedDateTime = Temporal.ZonedDateTime;
import PlainDate = Temporal.PlainDate;
import Now = Temporal.Now;

/** Tjeneste som gir tilgang til 'nå'.
 * Tjenesten eksisterer for at man i testsammenheng kan overstyre definisjonen av hva 'nå' skal være */
@Injectable({providedIn: 'root'})
export class Klokke {

    constructor(private gjeldendeTidssone: GjeldendeTidssone) {
    }

    /** Returnerer 'nå' som ZonedDateTime i brukers tidssone dersom ikke annet angitt. */
    nåSomZonedDateTime(tidssone = this.gjeldendeTidssone.brukersTidssone()): ZonedDateTime {
        return Now.zonedDateTimeISO(tidssone.somZoneId());
    }

    /** Returnerer 'nå' som PlainDate i brukers tidssone dersom ikke annet angitt. */
    nåSomPlainDate(tidssone = this.gjeldendeTidssone.brukersTidssone()): PlainDate {
        return Now.plainDateISO(tidssone.somZoneId());
    }

    /** Returnerer 'nå' som millisekunder siden epoch. */
    nåSomEpochMillisekunder(): number {
        return Now.instant().epochMilliseconds;
    }
}
